import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { GlobalService } from '../global.service';
import { Subscription } from "rxjs";
import { ReferredTermsComponent } from '../referred/components/referred-terms/referred-terms.component';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { PopupReferComponent } from '../referred/components/popup-refer/popup-refer.component';
import { PopupRedeemComponent } from '../referred/components/popup-redeem/popup-redeem.component';
import { PopupReferPaperlessComponent } from '../referred/components/popup-refer-paperless/popup-refer-paperless.component';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-referred',
  templateUrl: './referred.component.html',
  styleUrls: ['./referred.component.sass']
})
export class ReferredComponent implements OnInit {
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public currentList;
  public selectBan;
  public type;
  public info;
  public accounInfo;
  public redeemProgram;
  public screenActual = 1;
  public screenActual2 = 2;
  public delinquentStatusField;
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;
  public tabActive = 'Mis Equipos y Servicios';
  public screenView = 1;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, private router: Router, public dialog: MatDialog, public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, public global: GlobalService, private route: ActivatedRoute) {
    this.AngularFireAnalytics.setCurrentScreen("Programa Refiere y Gana");
    this.AngularFireAnalytics.logEvent("Programa Refiere y Gana-Screenview");
  }
  ngOnInit() {
    if (this.global.sessionReview() == true) {
      let statusField;
      let getAccount = JSON.parse(atob(sessionStorage.getItem("getAccountDetails")));
      this.redeemProgram = getAccount.qualification.RedeemProgram;
      this.accounInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
      let account = sessionStorage.getItem("selectBan");
      let subscriber = this.global.getSuscriberByDefault(atob(account));
      for (let i = 0; i < getAccount.SubscriberInfo.length; i++) {
        if (getAccount.SubscriberInfo[i].subscriberNumberField == subscriber) {
          statusField = getAccount.SubscriberInfo[i].subscriberStatusField;
        }
      }
      this.delinquentStatusField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.delinquentStatusField;
      this.global.suspendedAccount(statusField, atob(account), btoa(subscriber), getAccount.AccounInfo.billBalanceField,'referred');
      //this.global.suspendedAccount("S", atob(account), btoa(subscriber), getAccount.AccounInfo.billBalanceField,'referred');
      this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
      this.loadingScreenService.stopLoading();
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value);
      });
    }
  }

  refreshDataTo() {
    // let index = parseInt(event.target["selectedIndex"]);
    this.initializeData();
  }
  initializeData() {
    if (this.global.validateSession() === true) {
      this.global.refreshDataTo(this.token);
    }
  }
  dataLoading(sw) {
    this.delinquentStatusField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.delinquentStatusField;
    this.loadingScreenService.stopLoading();
  }
  mostrarPreguntasFrecuentes() {
    this.screenView = 2;
  }
  mostarTerminos() {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { checkTerms: true};
    this.dialog.open(ReferredTermsComponent, dialogConfig);
  }
  viewRefer() {

    if (this.global.validateSession() === true) {
      if (this.global.validateIfApplicable(this.accounInfo, this.info, this.redeemProgram) == true) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = { currentList: this.currentList, info: this.global.referredData,delinquent:this.delinquentStatusField};
        const dialogRef = this.dialog.open(PopupReferComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(value => {
          if (value != "cancel") {

          }
        });
      }
    }
  }
  viewRedeem() {
    if (this.global.validateSession() === true) {
      if (this.global.validateIfApplicable(this.accounInfo, this.info, this.redeemProgram) == true) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = { currentList: this.currentList, info: this.global.referredData,delinquent:this.delinquentStatusField};
        const dialogRef = this.dialog.open(PopupRedeemComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(value => {
          if (value != "cancel") {
            this.router.navigate(['redeem']);
          }
        });
      }
    }
  }
}
